import React, { useCallback, useMemo, useRef } from 'react';
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import GridConfig from './GridConfig';
import { withUserProfile } from '@withUserProfile';

export interface TrailerStopRow {
    trailerId: string;
    [key: string]: unknown;
}

interface StatusBarItem {
    label: string;
    filterCondition: string;
}

interface SpecialNeedsOption {
    value: string;
    text: string;
    [key: string]: unknown;
}

interface TrailerStopGridProps {
    stopData: TrailerStopRow[] | null;
    gridStatus?: string;
    glContainer?: unknown;
    userData?: {
        userProfile?: Record<string, unknown>;
    };
    specialNeedsOptions?: SpecialNeedsOption[];
}

const constructStatusBar = (filteredData: TrailerStopRow[]): StatusBarItem[] => {
    const totalCount = filteredData.length;
    return [
        {
            label: `${totalCount} Stops`,
            filterCondition: '',
        },
    ];
};

const TrailerStopGrid: React.FC<TrailerStopGridProps> = ({
    stopData,
    gridStatus,
    glContainer,
    userData,
    specialNeedsOptions,
}) => {
    const gridConfig = useMemo(
        () =>
            new GridConfig({
                userProfile: userData?.userProfile,
            }),
        [userData?.userProfile]
    );

    const config = gridConfig.config;
    const gridApiRef = useRef<unknown>(null);
    const onGridReady = useCallback(({ api }: { api: unknown }) => {
        gridApiRef.current = api;
    }, []);

    return (
        <DataGrid
            defaultColDef={config.defaultColDef}
            columnDefs={config.columns}
            config={config}
            rowSelection={config.rowSelection}
            rowDeselection={config.rowDeselection}
            rowData={stopData}
            onGridReady={onGridReady}
            panelLabel={(filteredData: TrailerStopRow[]) => (
                <StatusBar data={constructStatusBar(filteredData)} />
            )}
            layoutContainer={glContainer}
            getRowId={(params: { data: TrailerStopRow }) => params.data.plannedStopSequence}
            showErrorMessage={gridStatus}
            context={{ specialNeedsOptions }}
        />
    );
};

export default withUserProfile(TrailerStopGrid);
